<div class="container">

  <div class="container text-center mt-5">
    <span style="color:var(--primary-color);" class="fs-2 fw-bolder">Fisioterapia <span class="fw-medium ">integral </span> </span>
  </div>

  <div class="container px-4 py-2" id="icon-grid">

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center ">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Traumatología</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Masoterapia</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Parafinaterapia</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Termoterapia</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Ultrasonido</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Terapida del dolor</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Descontracturante</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Magnoterapia</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Rehabilitación física</h3>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6 text-secondary">Láser</h3>
        </div>
      </div>
    </div>
  </div>

</div>
